import React from 'react'
import LegalPage from '../components/LegalPage'

const CookiePolicy: React.FC = () => (
  <LegalPage
    document="cookiePolicy"
    sections={[
      'introduction',
      'whatAreCookies',
      {
        key: 'typesOfCookies',
        subsections: ['essential', 'analytics', 'functional', 'marketing'],
      },
      'howWeUseCookies',
      { key: 'cookieManagement', subsections: ['browserSettings', 'ourSettings'] },
      'thirdPartyCookies',
      'updatesToPolicy',
      'contact',
    ]}
  />
)

export default CookiePolicy
